module.exports = __webpack_public_path__ + "img/Personalized.3f1830c6.jpg";